import {Component, OnInit} from '@angular/core';
import {Category} from "../../shared/models/category";
import {ItemsService} from "../../core/http/items.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Tenant} from "../../shared/models/tenant";
import {Item} from "../../shared/models/item";
import {YesNoModalComponent} from "../../shared/components/yes-no-modal/yes-no-modal.component";
import {PrinterService} from "../../core/http/printer.service";
import {OrderService} from "../../core/http/order.service";

@Component({
  selector: 'app-tenant-overview',
  templateUrl: './tenant-overview.component.html',
  styleUrl: './tenant-overview.component.scss'
})
export class TenantOverviewComponent implements OnInit {

  tenants: Tenant[] = [];
  displayedColumns: string[] = ['guid', 'name', 'deleteOrders', 'delete'];

  constructor(private printerService: PrinterService, private orderService: OrderService, private dialog: MatDialog, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.printerService.getAllTenants().subscribe({
      next: (response) => {
        this.tenants = <Tenant[]> response;
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  deleteTenant(tenant: Tenant): void {
    this.dialog.open(YesNoModalComponent, {
      data: {text: 'Tenant ' + tenant.name + ' inkl. aller Konfigurationen wirklich löschen?'},
      width: '400px'
    }).afterClosed().subscribe(result => {
      if (result) {
        this.printerService.deleteTenant(tenant.guid).subscribe(result => {
          this._snackBar.open('Tenant ' + tenant.name + ' inkl. aller Konfigurationen gelöscht', 'Schließen', {duration: 3000});
          this.ngOnInit();
        });
      }
    });
  }

  deleteTenantOrders(tenant: Tenant): void {
    this.dialog.open(YesNoModalComponent, {
      data: {text: 'Alle Bestellungen von ' + tenant.name + ' wirklich löschen?'},
      width: '400px'
    }).afterClosed().subscribe(result => {
      if (result) {
        this.orderService.deleteAllTenantOrders(tenant.guid).subscribe(result => {
          this._snackBar.open('Alle Tenant Einträge von ' + tenant.name + ' gelöscht', 'Schließen', {duration: 3000});
          this.ngOnInit();
        });
      }
    });
  }

}
